"use strict";

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

var _crud = _interopRequireWildcard(require("@crud/crud"));

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
function sortWithRef(src, ref) {
  var result = Object.assign([], ref);
  var cursor = -1;
  src.forEach(function (e) {
    var idx = result.indexOf(e);

    if (idx === -1) {
      cursor += 1;
      result.splice(cursor, 0, e);
    } else {
      cursor = idx;
    }
  });
  return result;
}

var _default2 = {
  mixins: [(0, _crud.crud)()],
  props: {
    permission: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    hiddenColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ignoreColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      tableColumns: [],
      allColumnsSelected: true,
      allColumnsSelectedIndeterminate: false,
      tableUnwatcher: null,
      // 忽略下次表格列变动
      ignoreNextTableColumnsChange: false
    };
  },
  watch: {
    'crud.props.table': function crudPropsTable() {
      var _this = this;

      this.updateTableColumns();
      this.tableColumns.forEach(function (column) {
        if (_this.hiddenColumns.indexOf(column.property) !== -1) {
          column.visible = false;

          _this.updateColumnVisible(column);
        }
      });
    },
    'crud.props.table.store.states.columns': function crudPropsTableStoreStatesColumns() {
      this.updateTableColumns();
    }
  },
  created: function created() {
    this.crud.updateProp('searchToggle', true);
  },
  methods: {
    updateTableColumns: function updateTableColumns() {
      var _this2 = this;

      var table = this.crud.getTable();

      if (!table) {
        this.tableColumns = [];
        return;
      }

      var cols = null;

      var columnFilter = function columnFilter(e) {
        return e && e.type === 'default' && e.property && _this2.ignoreColumns.indexOf(e.property) === -1;
      };

      var refCols = table.columns.filter(columnFilter);

      if (this.ignoreNextTableColumnsChange) {
        this.ignoreNextTableColumnsChange = false;
        return;
      }

      this.ignoreNextTableColumnsChange = false;
      var columns = [];
      var fullTableColumns = table.$children.map(function (e) {
        return e.columnConfig;
      }).filter(columnFilter);
      cols = sortWithRef(fullTableColumns, refCols);
      cols.forEach(function (config) {
        var column = {
          property: config.property,
          label: config.label,
          visible: refCols.indexOf(config) !== -1
        };
        columns.push(column);
      });
      this.tableColumns = columns;
    },
    toDelete: function toDelete(datas) {
      var _this3 = this;

      this.$confirm("\u786E\u8BA4\u5220\u9664\u9009\u4E2D\u7684".concat(datas.length, "\u6761\u6570\u636E?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.crud.delAllLoading = true;

        _this3.crud.doDelete(datas);
      }).catch(function () {});
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      var _this4 = this;

      if (val === false) {
        this.allColumnsSelected = true;
        return;
      }

      this.tableColumns.forEach(function (column) {
        if (!column.visible) {
          column.visible = true;

          _this4.updateColumnVisible(column);
        }
      });
      this.allColumnsSelected = val;
      this.allColumnsSelectedIndeterminate = false;
    },
    handleCheckedTableColumnsChange: function handleCheckedTableColumnsChange(item) {
      var totalCount = 0;
      var selectedCount = 0;
      this.tableColumns.forEach(function (column) {
        ++totalCount;
        selectedCount += column.visible ? 1 : 0;
      });

      if (selectedCount === 0) {
        this.crud.notify('请至少选择一列', _crud.default.NOTIFICATION_TYPE.WARNING);
        this.$nextTick(function () {
          item.visible = true;
        });
        return;
      }

      this.allColumnsSelected = selectedCount === totalCount;
      this.allColumnsSelectedIndeterminate = selectedCount !== totalCount && selectedCount !== 0;
      this.updateColumnVisible(item);
    },
    updateColumnVisible: function updateColumnVisible(item) {
      var table = this.crud.props.table;
      var vm = table.$children.find(function (e) {
        return e.prop === item.property;
      });
      var columnConfig = vm.columnConfig;

      if (item.visible) {
        // 找出合适的插入点
        var columnIndex = this.tableColumns.indexOf(item);
        vm.owner.store.commit('insertColumn', columnConfig, columnIndex + 1, null);
      } else {
        vm.owner.store.commit('removeColumn', columnConfig, null);
      }

      this.ignoreNextTableColumnsChange = true;
    },
    toggleSearch: function toggleSearch() {
      this.crud.props.searchToggle = !this.crud.props.searchToggle;
    }
  }
};
exports.default = _default2;